import React from "react";
import { ArchiveRestore } from "lucide-react";

const RestoreAccount = ({ open, onClose, onConfirm }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative z-50 w-full max-w-md bg-white rounded-3xl shadow-2xl p-8 transform transition-all duration-300 scale-100 animate-fadeIn">
        {/* Icon */}
        <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-3xl bg-gradient-to-br from-[#FFF1ED] to-[#FFE4DC] shadow-lg">
          <ArchiveRestore
            className="text-green-500"
            size={36}
            strokeWidth={2.5}
          />
        </div>

        {/* Heading */}
        <h2 className="mt-6 text-2xl font-bold text-gray-900 text-center">
          Account Restored
        </h2>

        {/* Subtext */}
        <p className="mt-3 text-center text-gray-500 text-sm leading-relaxed max-w-sm mx-auto">
          Welcome back! Your account has been successfully restored. All your
          data and settings are intact.
        </p>

        {/* Divider */}
        <div className="my-6 h-px bg-gray-200" />

        {/* Buttons */}
        <div className="flex gap-4">
          <button
            onClick={onConfirm}
            className="flex-1 py-3 rounded-xl bg-gradient-to-r from-[#FF6943] to-[#ff8a6d] text-white font-semibold shadow-lg hover:brightness-105 active:scale-95 transition-all duration-200"
          >
            Continue
          </button>
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-xl border border-gray-300 text-gray-700 font-semibold hover:bg-gray-50 active:scale-95 transition-all duration-200"
          >
            Cancel
          </button>
        </div>
      </div>

      {/* Animation keyframes */}
      <style>
        {`
          @keyframes fadeIn {
            0% { opacity: 0; transform: scale(0.95); }
            100% { opacity: 1; transform: scale(1); }
          }
          .animate-fadeIn {
            animation: fadeIn 0.25s ease-out forwards;
          }
        `}
      </style>
    </div>
  );
};

export default RestoreAccount;
